const LogKibanaConstant = {
    // USER_ACTION: {
    //   SEARCH: 'SEARCH',
    //   CHAT: 'CHAT',
    // },
    SEARCH_ACTION: {
        KEY_WORD: 'KEYWORD',
        TAG_SUGGEST: 'TAG_SUGGEST',
        DRILL_DOWN: 'DRILL_DOWN',
        VIEW_CHANGE: 'VIEW_CHANGE',
        TAG_REMOVE: 'TAG_REMOVE',
    },
    ACTION_TYPE: {
        SEARCH: '検索（search）',
        KNOWLEDGE_ROBO: 'ナレッジロボ (Knowledge Robo)',
        CONTENT_OPERATION: 'コンテンツ操作（ContentOperation）',
        CHAT: 'チャット（Chat）',
        AI_CHAT: 'AIチャット（AIChat）'
    },
    ACTION_DETAIL: {
        SEARCH_KEY_WORD: 'searchButton',
        SEARCH_TAG_SUGGEST: 'tagSuggest',
        SEARCH_DRILL_DOWN: 'drillDown',
        SEARCH_VIEW_CHANGE: 'viewChange',
        SEARCH_TAG_REMOVE: 'tagRemove',
        CATEGORY_SELECT: 'categorySelect',
        TAG_GROUP_SELECT: 'tagGroupSelect',
        TAG_SELECT: 'tagSelect',
        CLICK_KNOWLEDGE: 'clickKnowledge',
        CONTENT_OPERATION_VIEW: 'view',
        CONTENT_OPERATION_CREATE: 'create',
        CONTENT_OPERATION_CREATE_CSV: 'create(CSV)',
        CONTENT_OPERATION_CREATE_MANUAL: 'create(manual)',
        CONTENT_OPERATION_EDIT: 'edit',
        CONTENT_OPERATION_EDIT_BY_CSV: 'edit(CSV)',
        INTERACT_WITH_AI: 'InteractWithAI',
        REFERENCES_AS_AI_PROMPT: 'References as AI prompt',
        ENQUETE: 'enquete',
        KNOWLEDGE_SEARCH_CONDITION_SETTING: 'Knowledge search condition setting',
        
    },
    SEARCH_TARGET: {
        CHAT: 'chat',
        BODY: 'body',
    },
    CONTENT_TYPES_TICKET: {
        QA: '問合せ',
        TASK: '課題',
        KNOWLEDGE: 'ナレッジ',
        NOTICE: 'お知らせ'
    },
    OPERATION_SCREEN: {
        PUBLIC: 'public',
        SOLUTION_DESK: 'solutiondesk'
    },
    DATE_TYPE: {
        ON: 'on',
        OFF: 'off',
    },
    SORT_TYPE: {
        CREATED_AT: 'コンテンツの投稿日順',
        UPDATED_AT: 'コンテンツの更新日順',
        SIMILAR: 'コンテンツの類似度順',
        PRIVATE_BOOKMARK_ASC: '個人用ブックマーク件数が少ない順',
        PRIVATE_BOOKMARK_DESC: '個人用ブックマーク件数が多い順'
    },
    VIEW_NAME: {
        VIEW_QA: 'View QA',
        VIEW_HELP_DESK: 'View Helpdesk',
        VIEW_KNOWNLEDGE: 'View Knownledge',
        VIEW_PUBLIC_KNOWNLEDGE: 'View Public Knownledge',
    },
    QA_VIEW_NAME: {
        IN_CHARGE_QA_VIEW: '新規問い合わせ',
        NOTICE_VIEW: 'お知らせ',
        DRAFT_QA_VIEW: '下書き',
        ARCHIVE_QA_VIEW: 'アーカイブ',
        INVITATION_VIEW: '申請チケット'
    },
    DUMMY_TEXT: 'solutiondesk',
    DATE_UNIT: {
        DAY: 'day',
        WEEK: 'week'
    },
    CONTENT_OPERATION_ACTION: {
        ADD: 'ADD',
        EDIT: 'EDIT',
        VIEW: 'VIEW',
        EDIT_FROM_LIST: 'EDIT_FROM_LIST',
        USE_AI_PROMPT: 'USE_AI_PROMPT'
    },
    CHAT_ACTION_LOCATION: {
        CUSTOMER: 'customer',
        PROJECT: 'project',
        ESCALATION: 'escalation',
        KNOWLEDGE: 'knowledge',
    },
    TICKET_NAME: {
        NULL: '概要（現在未記入）'
    },
    CONTENT_TYPE: {
        QA: '問合せ', //ticket QA, ticket escalate, ticket delegate have ticket type is 問合せ
        TASK: 'タスク',
        KNOWLEDGE: 'ナレッジ',
        NOTICE: 'お知らせ',
        B2B_PARTNER_EXTERNAL: '既存サービスデスクプロジェクトを選ぶ',
        B2B_PARTNER_INTERNAL: 'パートナープロジェクト作成',
        B2B_SUPPORT_EXTERNAL: '既存プロジェクトを選ぶ',
        B2B_SUPPORT_INTERNAL: 'サポート対象プロジェクト作成',
    },
    UNASSIGN: 'Unassigned',
    KNOWLEDGE_ROBO: {
        CLICK_KNOWLEDGE: 'clickKnowledge',
        ENQUETE: 'enquete'
    },
    CONTENT_OPERATION : {
        EDIT : 'EDIT_TICKET_CONTENT'
    },
    AI_CHAT_SCREEN: {
        AI: 'AI',
        ROBO: 'Robo'
    },
    ENQUETE_FOR: {
        AI: 'AI',
        ROBO: 'Robo'
    },
    AI_CHAT: {
        SEARCH_CONDITION_SETTING: "SEARCH_CONDITION_SETTING"
    },
    AI_CHAT_ACTION_TYPE: {
        UPDATE_SEARCH_CONDITION: 'UPDATE_SEARCH_CONDITION',
        USING_KNOWLEDGE_TICKET_LIST: 'USING_KNOWLEDGE_TICKET_LIST',
        NOT_USING_KNOWLEDGE_TICKET_LIST: 'NOT_USING_KNOWLEDGE_TICKET_LIST'
    },
    TICKET_CREATION_SCREEN: {
        SOLUTIONDESK: 'solutiondesk',
        KNOWLEDGE_ROBO: 'knowledgeRobo',
        PUBLIC_WEB_FORM: 'publicWebForm'
    },
    ALL_KNOWLEDGE_IN_ORG: {
        KEY: 'ALL_KNOWLEDGE_IN_ORG',
        VALUE: '組織内全ナレッジ'
    }
};

export default LogKibanaConstant;
